import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Bubble, Button, Segment } from 'tea-component';
import { useIntl, history, connect } from 'umi';

import { getExplainVal } from '@/pages/dashboard/utils/getExplainVal';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';

import './index.scss';
import { ISegmentMetric, ISegmentMoreCoProps } from './type';
import { dynamicString } from '@home/utils/dynamicString';
import { getName } from '@home/utils/common';
import {
  filterSegmentMetricsByTabMetric,
  resolveTabListByTimeType,
} from '@/pages/dashboard/utils/metricUtils';

const SegmentMoreCo = (props: ISegmentMoreCoProps) => {
  const { config, data, changeData, children, explainInfo, restProps, initMetric = 'new_users' } = props || {};
  
  const { dataKey, tabList, tabMetric: configTabMetric, isShowCollapseButton = true } =
    config || {};

  const { metric = '' } = data || {};

  const metricsInfo = data?.metricsInfo;
  const tabMetric = configTabMetric ?? data?.tabMetric;

  const { locale, formatMessage } = useIntl();

  const isEn = locale === 'en-US';

  const { filterVal } = useContext(FilterContext);
  const { timeType = 'Day' } = filterVal || {};

  const newTabList = useMemo(() => {
    const baseList = resolveTabListByTimeType<ISegmentMetric>(tabList, timeType);
    return filterSegmentMetricsByTabMetric(baseList, tabMetric, timeType);
  }, [tabList, tabMetric, timeType]);

  const historyParam: any = history?.location?.state;
  const jumpMetric = historyParam ? JSON.parse(historyParam)?.indicators : undefined;

  const [isExpanded, setIsExpanded] = useState(historyParam);

  const segmentMetricsList = useMemo(
    () =>
      newTabList.map((item: any) => ({
        ...item,
        translatedText: getName(isEn, dynamicString(item.name, data), dynamicString(item.nameCn, data)) || ''
      })),
    [newTabList, locale, data, isEn],
  );
  const getTopCardMetrics = (
    formattedMetrics: ISegmentMetric[],
    metric: string,
  ): ISegmentMetric | undefined => {
    const initMetricsObj = formattedMetrics.find((item) => {
      const  metricLower = initMetric?.toLowerCase();
      return item?.resName?.toLowerCase() === metricLower || item?.id?.toLowerCase() === metricLower|| item?.indicatorsName?.toLowerCase() === metricLower;
    });
    const tempTopCard: ISegmentMetric =  formattedMetrics.find((item) => {
      // bug修复，国荣之前的代码会导致跳转页面后，无法切换指标，原因是之前代码有indicators时会直接返回indicators的指标
      // 当前迭代紧急临时处理，在service层通过indicators设置metrcis，在本组件进行下面的兼容处理
      // 跳转配置的可能是id可能是指标key，所以这里进行兼容处理
      const  metricLower = metric?.toLowerCase();
      return item?.resName?.toLowerCase() === metricLower || item?.id?.toLowerCase() === metricLower|| item?.indicatorsName?.toLowerCase() === metricLower;
    }) || initMetricsObj || formattedMetrics?.[0];
    return tempTopCard;
  };

  const selectedTopCard = getTopCardMetrics(segmentMetricsList, metric);

  useEffect(() => {
    if(!jumpMetric) return;
    const  jumpMetricLower = jumpMetric?.toLowerCase();
    const findMetrics = newTabList?.filter(item => item?.resName?.toLowerCase() === jumpMetricLower || item?.indicatorsName?.toLowerCase() === jumpMetricLower|| item?.id?.toLowerCase() === jumpMetricLower) || [];

    if(findMetrics?.length === 0 ) {
      changeData?.(dataKey, initMetric || newTabList?.[0]?.resName);
    } else {
      changeData?.(dataKey, findMetrics?.[0]?.resName);
    }
  }, [newTabList, jumpMetric, dataKey]);

  const segmentChange = (value: string) => {
    changeData?.(dataKey, value);
  };

  // Segment列表
  const segmentList = useMemo(
    () =>
      segmentMetricsList?.map((item: any) => {
     
        const explain = getExplainVal(explainInfo, item?.rainbowKey, locale, dynamicString(item.explainEn, data), dynamicString(item.explainCn, data));

        return {
          text: (
            <Bubble
              content={
                explain ? (
                  <p
                    className="db-SwitchChart__titleBubble-infoTxt"
                    dangerouslySetInnerHTML={{ __html: explain?.replaceAll('\\n', '<br/>') }}
                  />
                ) : (
                  ''
                )
              }
              dark
              className="metrics-segment__item-bubble"
              placement="top-start"
            >
              {item?.translatedText}
            </Bubble>
          ),
          // 转为字符串，实现选中效果
          value: item?.resName,
        };
      }) || [],
    [segmentMetricsList, locale],
  );

  return (
    <>
      <div className="dbd-segment-more-co">
        <Segment
          className={`segment-light ${isExpanded || !isShowCollapseButton ? 'segment-light-show' : 'segment-light-hide'}`}
          value={selectedTopCard?.resName}
          onChange={segmentChange}
          options={segmentList}
        />

        {isShowCollapseButton && (
          <Button
            type="link"
            className="dateComparison-flex-btn"
            onClick={() => {
              setIsExpanded(!isExpanded);
            }}
          >
            <span className="button-text">
              {formatMessage({
                id: isExpanded
                  ? 'comparison_analysis_date_comparison_key_metrics'
                  : 'comparison_analysis_date_comparison_more_metrics',
              })}
            </span>
          </Button>
        )}
      </div>

      {React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          selectedMetrics: selectedTopCard,
          timeType,
          restProps,
        }),
      )}
    </>
  );
};

export default connect((state: any) => ({
  explainInfo: state.dashboard?.explainInfo,
}))(SegmentMoreCo);
